// src/features/tag/TagApi.ts

import { webApi } from '@/shared/api/WebApi';
import type { TagListResponse } from '@/lib/types/Tag';

export class TagApi {
  static async getTags(cId: number): Promise<TagListResponse> {
    return webApi.get<TagListResponse>('tags', { cId });
  }
}
